export const CUSTOM_STATUS_CODE_FILE_SUBMIT = "CUSTOM_STATUS_CODE_FILE_SUBMIT";


// WEBPACK FOOTER //
// ./src/constants/customStatusCodes.js